// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* toastAnimations.css */\n@keyframes slideIn {\n  from {\n    transform: translateX(120%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.toast-animate {\n  animation: slideIn 0.4s ease-out;\n}\n\n.toast-success {\n  background-color: #28a745 !important;\n  color: white;\n}\n\n.toast-danger {\n  background-color: #dc3545 !important;\n  color: white;\n}\n\n.toast-info {\n  background-color: #0dcaf0 !important;\n  color: black;\n}\n", ""]);
// Exports
module.exports = exports;
